import request from '@/utilsCloud/request'
import port from './port'


// 获取单位系统课程当前配置
export function getEntpCourseConfigCurrent(data) {
  return request({
    url: port.course + '/courseConfig/getEntpCourseConfigCurrent',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}


// 查询课程详情
export function getUserCourseStudyDetail(query) {
  return request({
    url: port.course + '/home/getUserCourseStudyDetail',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

export function getStudyccCountToday(query) {
  return request({
    url: port.course + '/home/getStudyccCountToday',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: query
  })
}

export function saveUserStudyTime(data) {
  return request({
    url: port.course + '/home/saveUserStudyTime',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}


export function saveStudyPhoto(data) {
  return request({
    url: port.course + '/videoPlay/saveStudyPhoto',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}


export function getEnterpriseWebsite(query) {
  return request({
    url: port.biz + '/enterprise/getEnterpriseWebsite',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

export function addCustomerInformationInfo(data) {
  return request({
    url: port.course + '/customerInformationInfo/addCustomerInformationInfo',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

// 发表评论
export function addCourseComment(data) {
  return request({
    url: port.course + '/comment/addCourseComment',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

// 发表评论
export function getCourseCommentListHome(query) {
  return request({
    url: port.course + '/comment/getCourseCommentListHome',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 满意度调查问卷
export function saveTrainQuestionnaire(data) {
  return request({
    url: port.course + '/videoPlay/saveTrainQuestionnaire',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    params: data
  })
}

// 按照章节顺序看课
export function getVideoIds(query) {
  return request({
    url: port.course + '/videoPlay/getVideoIds',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/apiCloud/coursePlay.js